// extracted by mini-css-extract-plugin
export default {"discount":"Ufo5u","description":"Vy9bT","dark":"Hpgqg","discountIcon":"Ka3S9","white":"wR6ea","icon":"bH62Y","aboutDiscount":"ZAWuo","tooltip":"roFMD"};